export default {
  setBoxTypes(store, boxTypes) {
    store.commit('setBoxTypes', boxTypes);
  },
};
